import { Formik, FormikHelpers } from "formik";
import { DisplayMachineGroupsForm } from "./DisplayMachineGroupsForm";

type MachineGroupsFormProps = {};

export const MachineGroupsForm: React.FC<MachineGroupsFormProps> = ({}) => {
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {};

  return (
    <>
      {
        <Formik
          initialValues={{}}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          <>
            <div style={{ margin: "5px" }}>
              <DisplayMachineGroupsForm />
            </div>
          </>
        </Formik>
      }
    </>
  );
};
